import { transition } from 'd3-transition';
import { patchAttrTween } from './transition/patchAttrTween';

transition.prototype.end = function (value: any) {
  return new Promise<void>((resolve) => {
    if (this.empty()) {
      // Return fulfilled promise when nothing in selection.
      return resolve();
    }
    let n = 0;
    this.each(() => {
      ++n;
    }).on('end.promise', () => {
      if (!--n) {
        resolve(value);
      }
    });
  });
};

// Patch 'attrTween' to prevent updating specific attributes with invalid values
patchAttrTween();

export * from 'd3-transition';
